/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  TabContent,
  TabPane,
  NavLink,
} from "reactstrap";
// import { useToast } from "@/components/ui/use-toast";
import classnames from "classnames";
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";

import { Link, redirect, useNavigate, useSearchParams } from "react-router-dom";
import RepresentativeInformation from "./representativeInformation";
import BusinessInformation from "./businessInformation";
import LegalDocumentation from "./legalDocumentation";
import HoldersInformation from "./holdersInformation";
import FinancialInformation from "./financialInformation";
import CheckInformation from "./checkInformation";
import { toast } from "react-toastify";
import ValidationRepresentativeInfo from "./validationRepresentativeInfo";
import PasswordInformation from "./representativePassword";
import { createPublicToken } from "../../../helpers/dataBackend";
import { setAuthorization } from "../../../helpers/api_helper";
import {
  checkRegisterProgress,
  completeUpload,
  continueRegisterProgress,
  getCompanyFinalInfo,
  postBussinessInformation,
  postCompanyFinantialInfo,
  postCompanyFistStep,
  postLegalDocuments,
  postShareHolders,
  postSubimitBusinessRegister,
  uploadChunk,
  // savePDF,
} from "../../../helpers/AuthType/authBackend";
import LanguageDropdown from "Components/Common/LanguageDropdown";
// import axios from "axios";

const StepsRegisterBusiness = () => {
  //meta title
  document.title = "Ditobanx";

  const stepsName = [
    { code: "BRD", name: "Representante Legal" },
    { code: "BRD", name: "Validación" },
    { code: "BRD", name: "Contraseña" },
    { code: "IE", name: "Información de la Empresa" },
    { code: "DL", name: "Documentación Legal" },
    { code: "AB", name: "Accionistas y Beneficiarios" },
    { code: "IF", name: "Información Financiera" },
    { code: "RF", name: "Revisión y Aceptación" },
  ];

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [codeProcess, setCodeProcess] = useState<string>("");
  const [userId, setUserId] = useState<any>();
  const [tokenExpired, setTokenExpired] = useState<boolean>(false);
  const tokenParam = searchParams.get("token");
  const [btnDisabled, setBtnDisabled] = useState<boolean>(false);
  const [existingProcess, setExistingProcess] = useState<boolean>(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showError, setShowError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  let userIdTemp: any;

  // Individual registration data
  const [businessData, setBusinessData] = useState<{
    representativeInfo?: any;
    representativeValidation?: any;
    passwordInfo?: any;
    businessInfo?: any;
    documentationInfo?: any;
    holdersInfo?: any;
    financialInfo?: any;
  }>({});

  const [passedSteps, setPassedSteps] = useState([1]);

  const nextStep = () => {
    const maxSteps = stepsName.length;
    if (currentStep === maxSteps) {
      redirect("/individual-confirmation");
    }
    if (currentStep < maxSteps) {
      setCurrentStep(currentStep + 1);
      window.scrollTo(0, 0);
    }
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
    window.scrollTo(0, 0);
  };

  const handleCloseConfirmation = () => {
    setShowConfirmationModal(false);
    // handleDataPrint(); // Si deseas imprimir datos luego
  };

  const handleCloseError = () => {
    setShowError(false);
    // handleDataPrint(); // Si deseas imprimir datos luego
  };

  const getPublicToken = async () => {
    const responsePublicToken = await createPublicToken();
    // console.log(responsePublicToken);
    localStorage.setItem("publicToken", responsePublicToken.token);
    setAuthorization(responsePublicToken.token); // Guardar el token antes de continuar

    if (tokenParam) {
      // console.log("Token Param", tokenParam);
      const token = JSON.parse(atob(tokenParam.split(".")[1]));
      // console.log("Token", token);
      setCodeProcess(token.code);
      setUserId(token.userId);

      const maximoSteps = stepsName.length;

      if (token.exp * 1000 < Date.now()) {
        console.log("Token expired");
        // alert("Token expired");
        setTokenExpired(true);
      }

      stepsName.forEach((item, index) => {
        if (item.code === token.code) {
          if (index === maximoSteps - 1) {
            getFinalData(token.userId);
            // console.log("Datax", individualData);
          }
          setCurrentStep(index + 1);
        }
      });
    }
  };
  const getFinalData = async (userID: number) => {
    try {
      if (localStorage.getItem("publicToken")) {
        const response = await getCompanyFinalInfo(userID);
        const responseData = JSON.parse(response.data);
        console.log("Response", responseData);
        if (responseData) {
          setBusinessData({
            representativeInfo: responseData.representativeInfo,
            businessInfo: responseData.companyInfo,
            documentationInfo: responseData.documents,
            holdersInfo: responseData.shareholders,
            financialInfo: responseData.financialInfo,
          });
        }
      }
    } catch (error) {
      console.log("Hubo un problema al guardar la información.");
      console.log(error);
    }
  };
  useEffect(() => {
    getPublicToken();
  }, []);

  const uploadFileChunks = async (chunks: any, uploadId: any, type: any) => {
    const totalChunks = chunks.length;

    // console.log({ chunks, uploadId, type });

    for (let i = 0; i < totalChunks; i++) {
      const payload = {
        uploadId,
        // filename: file.name,
        chunkIndex: i,
        totalChunks,
        chunkBase64: chunks[i],
        type, // Ej: "selfie", "front", etc.
      };
      // console.log(payload);
      await uploadChunk(payload);
    }

    // Notificamos que se terminó de subir
    // console.log("userID: ", userIdTemp);
    await completeUpload({
      uploadId,
      // filename: file.name,
      type,
      userId: userIdTemp,
    });

    return uploadId;
  };

  // CONTINUAR PROCESO
  const handleContinueProcess = async () => {
    // console.log("Click");
    setBtnDisabled(true);
    try {
      const response = await continueRegisterProgress({
        email: businessData.representativeInfo.email,
      });
      // console.log("Response", { response });

      setExistingProcess(false); // Cierra modal actual
      setShowConfirmationModal(true); // Abre nuevo modal
    } catch (error) {
      console.error("Error al continuar:", error);
      setBtnDisabled(false);
    }
  };

  // Representante Legal
  const handleRepresentativeInfoSubmit = async (data: any) => {
    setBusinessData({ ...businessData, representativeInfo: data });
    // console.log("Datos del Representante", data);
    try {
      const response = await checkRegisterProgress({
        email: data.email,
      });
      // console.log("Response", response.data);
      const dataResponse = JSON.parse(response.data);
      if (dataResponse.currentStatus?.code === "RC") {
        setErrorMessage(
          `El registro con el correo ${data.email} ya se encuentra completo`
        );
        setShowError(true);
        return;
      }
      if (
        dataResponse.currentStatus?.code &&
        dataResponse.currentStatus?.code !== "RC"
      ) {
        setExistingProcess(true); // Abre modal de confirmación
      } else {
        toast.success("Tus datos personales han sido guardados exitosamente.");
        nextStep();
      }
    } catch (error: any) {
      console.log("Error", error);
    }
  };

  //VALIDACION DEL REPRESENTANTE
  const handleRepresentativeValidation = (data: any) => {
    setBusinessData({ ...businessData, representativeValidation: data });
    toast.success("Tus datos personales han sido guardados exitosamente.");
    nextStep();
  };

  //CONTRASENA DEL REPRESENTANTE
  const handleRepresentativePassword = async (data: any) => {
    setBusinessData({ ...businessData, passwordInfo: data });

    try {
      const { document1, selfie, document_back, document_front, ...info } =
        businessData.representativeInfo;
      // console.log(document_front?.chunksImg);

      const response = await postCompanyFistStep({
        representativeInfo: info,
        passwordInfo: data,
      });

      const userData = JSON.parse(response.data);
      console.log(userData);
      if (userData.id) {
        console.log(userData.id);
        userIdTemp = userData.id;
        setUserId(userData.id);
        if (document_front && document_front?.chunksImg) {
          await uploadFileChunks(
            document_front?.chunksImg?.chunks,
            document_front?.chunksImg?.uploadId,
            document_front?.name
          );
        }
        if (document1 && document1?.chunksImg) {
          await uploadFileChunks(
            document1?.chunksImg?.chunks,
            document1?.chunksImg?.uploadId,
            document1?.name
          );
        }
        if (document_back && document_back?.chunksImg) {
          await uploadFileChunks(
            document_back?.chunksImg?.chunks,
            document_back?.chunksImg?.uploadId,
            document_back?.name
          );
        }
        if (selfie && selfie?.chunksImg) {
          await uploadFileChunks(
            selfie?.chunksImg?.chunks,
            selfie?.chunksImg?.uploadId,
            selfie?.name
          );
        }
      }
      if (userData?.error === true) {
        setErrorMessage(userData?.message);
        setShowError(true);
      }
      if (userData.id) {
        nextStep();
      }

      //INICIO PARA GUARDAR IMAGENES

      // Subida de imágenes con manejo individual de errores
      // const tryUpload = async (field: string, file: any) => {
      //   try {
      //     if (file?.base64) {
      //       await saveImages({ userId: userData.id, [field]: file });
      //     }
      //   } catch (err: any) {
      //     console.warn(`Error al subir ${field}:`, err.message);
      //   }
      // };

      // await tryUpload("document_front", document_front);
      // await tryUpload("document_back", document_back);
      // await tryUpload("selfie", selfie);
      // await tryUpload("document1", document1);
    } catch (error: any) {
      console.log("Error general:", error.message);
      // Puedes activar el modal de error general si aplica
      setErrorMessage(error.message || "Hubo un problema");
      setShowError(true);
    }
  };

  // INFRORMACION DE LA EMPRESA
  const handleBusinessInfoSubmit = async (data: any) => {
    setBusinessData({ ...businessData, businessInfo: data });

    try {
      const response = await postBussinessInformation({
        userId: userId,
        businessInfo: data,
      });
      // console.log("Response", response.result);
      const userData = JSON.parse(response.data);
      const dataResponse = JSON.parse(response.data);
      if (dataResponse?.error === true) {
        setErrorMessage(dataResponse?.message);
        setShowError(true);
      }
      if (userData.id) {
        nextStep();
      }
    } catch (error: any) {
      console.log("Error", error);
    }
  };

  // DOCUMENTACION LEGAL
  const handleDocumentationInfoSubmit = async (data: any) => {
    setBusinessData({ ...businessData, documentationInfo: data });

    try {
      console.log(data);
      if (data === true) {
        const response = await postLegalDocuments({
          userId: userId,
          // documentationInfo: data,
        });
        const userData = JSON.parse(response.data);
        if (userData.id) {
          alert("Tus datos personales han sido guardados exitosamente.");
          nextStep();
        } else {
          alert("Error al guardar la información de la empresa.");
        }
      }
    } catch (error: any) {
      console.log("Error", error);
    }
  };

  // ACCIONISTAS Y BENEFICIARIOS
  const handleHoldersInfoSubmit = async (data: any) => {
    setBusinessData({ ...businessData, holdersInfo: data });
    try {
      const response = await postShareHolders({
        userId: userId,
        shareholdersInfo: data,
      });
      console.log(response);
      if (response) {
        toast.success("Tus datos personales han sido guardados exitosamente.");
        nextStep();
      } else {
        alert("Error al guardar la información de la empresa.");
      }
    } catch (error: any) {
      console.log("Error", error);
      setShowError(true);
    }
  };

  //INFORMACION FINANCIERA
  const handleFinancialInfoSubmit = async (data: any) => {
    setBusinessData({ ...businessData, financialInfo: data });

    // console.log(data);
    try {
      // console.log(data);
      const response = await postCompanyFinantialInfo({
        userId,
        financialInfo: data,
      });
      // console.log(response);
      const userData = JSON.parse(response.data);
      if (userData?.error === true) {
        setErrorMessage(userData?.message);
        setShowError(true);
      }
      if (userData.id) {
        toast.success("Tus datos personales han sido guardados exitosamente.");
        getFinalData(Number(userId));
        nextStep();
      } else {
        alert("Hubo un error al guardar la informacion");
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  // REVISICION FINAL
  const handleReviewSubmit = async (data: any) => {
    try {
      const response = await postSubimitBusinessRegister({
        userId,
        checkInfo: data,
      });
      // console.log(response);
      const userData = JSON.parse(response.data);
      if (userData.id) {
        toast.success("Tus datos personales han sido guardados exitosamente.");
        navigate("/business-confirmation", {
          state: {
            email: businessData.representativeInfo.email,
            businessName: businessData.businessInfo.legalBusinessName,
          },
        });
      } else {
        alert("Algo salio mal!!");
      }
    } catch (error) {}
    toast.success("Tus datos personales han sido guardados exitosamente.");
    nextStep();
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* <button onClick={handleDataPrint}>Print Data</button> */}
          <Row className="justify-content-center mt-lg-5">
            <Col xl={10} sm={10}>
              <Card>
                <CardBody>
                  <div id="kyc-verify-wizard" className="wizard clearfix">
                    <div
                      className="steps clearfix"
                      style={{
                        display: "flex",
                        overflowX: "auto",
                        WebkitOverflowScrolling: "touch",
                        backgroundColor: "#f7f7f7",
                        borderRadius: "5px",
                        padding: "10px",
                        // gap: "10px",
                        scrollbarWidth: "thin",
                      }}
                    >
                      {stepsName.map((item: any, index: any) => (
                        <div
                          className={classnames({
                            current: currentStep === index + 1,
                          })}
                          style={{
                            flex: "0 0 auto",
                            minWidth: "120px",
                            // maxWidth: "160px",
                            width: `${100 / stepsName.length}%`,
                            backgroundColor:
                              currentStep === index + 1
                                ? "#e0e0e0"
                                : "transparent",
                            textAlign: "center",
                            borderRadius: "5px",
                            padding: "5px",
                          }}
                        >
                          <NavLink
                            className={classnames({
                              active: currentStep === index + 1,
                            })}
                            disabled={!passedSteps.includes(index + 1)}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              paddingTop: "10px",
                              paddingBottom: "10px",
                            }}
                          >
                            <span className="number">{index + 1}</span>
                            <p style={{ margin: 0 }}>{item.name}</p>
                          </NavLink>
                        </div>
                      ))}
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "10px",
                      }}
                    >
                      <LanguageDropdown />
                    </div>
                    <div className="content clearfix">
                      <TabContent
                        activeTab={currentStep}
                        className="twitter-bs-wizard-tab-content"
                      >
                        {/* REPRESENTANTE */}
                        {currentStep === 1 && (
                          <TabPane
                            tabId={1}
                            id="personal-info"
                            className="body current"
                          >
                            <div style={{ marginBottom: "30px" }}>
                              <h1>{stepsName[currentStep - 1].name}</h1>
                              <p>Registro para representante legal</p>
                            </div>
                            <RepresentativeInformation
                              onSubmit={handleRepresentativeInfoSubmit}
                              onBack={prevStep}
                              data={businessData}
                            />
                          </TabPane>
                        )}
                        {/* VALIDACION */}
                        {currentStep === 2 && (
                          <TabPane
                            tabId={2}
                            id="checkout"
                            className="body current"
                          >
                            <div style={{ marginBottom: "30px" }}>
                              <h1>{stepsName[currentStep - 1].name}</h1>
                              <p>Registro para persona natural</p>
                            </div>
                            <ValidationRepresentativeInfo
                              onSubmit={handleRepresentativeValidation}
                              onBack={prevStep}
                              data={businessData}
                            />
                          </TabPane>
                        )}
                        {/* CONTRASENA */}
                        {currentStep === 3 && (
                          <TabPane
                            tabId={3}
                            id="checkout"
                            className="body current"
                          >
                            <div style={{ marginBottom: "30px" }}>
                              <h1>{stepsName[currentStep - 1].name}</h1>
                              <p>Registro para persona natural</p>
                            </div>
                            <PasswordInformation
                              onSubmit={handleRepresentativePassword}
                              onBack={prevStep}
                              data={businessData}
                            />
                          </TabPane>
                        )}
                        {/* EMPRESA */}
                        {currentStep === 4 && (
                          <TabPane
                            tabId={4}
                            id="validation"
                            className="body current"
                          >
                            <div style={{ marginBottom: "30px" }}>
                              <h1>{stepsName[currentStep - 1].name}</h1>
                              <p>Registro para la empresa</p>
                            </div>
                            <BusinessInformation
                              onSubmit={handleBusinessInfoSubmit}
                              onBack={prevStep}
                              data={businessData}
                            />
                          </TabPane>
                        )}
                        {/* DOCUMENTACION LEGAL */}
                        {currentStep === 5 && (
                          <TabPane
                            tabId={5}
                            id="password-info"
                            className="body current"
                          >
                            <div style={{ marginBottom: "30px" }}>
                              <h1>{stepsName[currentStep - 1].name}</h1>
                              <p>A continuación sube la documentación legal</p>
                            </div>
                            <LegalDocumentation
                              onSubmit={handleDocumentationInfoSubmit}
                              onBack={prevStep}
                              data={businessData}
                              userId={userId}
                            />
                          </TabPane>
                        )}
                        {/* ACCIONISTAS */}
                        {currentStep === 6 && (
                          <TabPane
                            tabId={6}
                            id="identity-verification"
                            className="body current"
                          >
                            <div style={{ marginBottom: "30px" }}>
                              <h1>{stepsName[currentStep - 1].name}</h1>
                              <p>Registro de Accionistas</p>
                            </div>
                            <HoldersInformation
                              onSubmit={handleHoldersInfoSubmit}
                              onBack={prevStep}
                              data={businessData}
                            />
                          </TabPane>
                        )}
                        {/* INFO FINANCIERA */}
                        {currentStep === 7 && (
                          <TabPane
                            tabId={7}
                            id="address-info"
                            className="body current"
                          >
                            <div style={{ marginBottom: "30px" }}>
                              <h1>{stepsName[currentStep - 1].name}</h1>
                              <p>Información financiera la empresa</p>
                            </div>
                            <FinancialInformation
                              onSubmit={handleFinancialInfoSubmit}
                              onBack={prevStep}
                              data={businessData}
                              userId={userId}
                            />
                          </TabPane>
                        )}
                        {/* REVISION */}
                        {currentStep === 8 && (
                          <TabPane
                            tabId={8}
                            id="financial-info"
                            className="body current"
                          >
                            <div style={{ marginBottom: "30px" }}>
                              <h1>{stepsName[currentStep - 1].name}</h1>
                              <p>Revisión de la Información</p>
                            </div>
                            <CheckInformation
                              onSubmit={handleReviewSubmit}
                              onBack={prevStep}
                              data={businessData}
                            />
                          </TabPane>
                        )}
                        {/* CHECKOUT */}
                        {/* {currentStep === 7 && (
                          <TabPane
                            tabId={7}
                            id="checkout"
                            className="body current"
                          >
                            <div style={{ marginBottom: "30px" }}>
                              <h1>{stepsName[currentStep - 1]}</h1>
                              <p>Registro para persona natural</p>
                            </div>
                            <HoldersInformation
                              onSubmit={handleBasicInfoSubmit}
                              onBack={prevStep}
                            />
                          </TabPane>
                        )} */}
                      </TabContent>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* MODAL PARA CONTINUAR EL PROCESO */}
      {existingProcess && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>
            <h2 style={styles.modalTitle}>¿Continuar proceso?</h2>
            <p style={styles.modalText}>
              Ya existe un proceso en curso. ¿Deseas continuar donde lo dejaste?
            </p>
            <div style={styles.buttonGroup}>
              <button
                style={styles.cancelButton}
                onClick={() => setExistingProcess(false)}
              >
                Cancelar
              </button>
              <button
                style={styles.confirmButton}
                onClick={handleContinueProcess}
                // disabled={btnDisabled}
              >
                Continuar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de confirmación */}
      {showConfirmationModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>
            <h2 style={styles.modalTitle}>¡Correo enviado!</h2>
            <p style={styles.modalText}>
              Hemos enviado un enlace a tu correo electrónico. Ya puedes cerrar
              esta página y continuar el registro con el enlace compartido.
            </p>
            <div style={{ marginTop: "20px" }}>
              <button
                style={styles.confirmButton}
                onClick={handleCloseConfirmation}
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      )}

      {showError && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>
            <h2 style={styles.modalTitle}>¡Hubo un Problema!</h2>
            <p style={styles.modalText}>{errorMessage}</p>
            <div style={{ marginTop: "20px" }}>
              <button style={styles.confirmButton} onClick={handleCloseError}>
                Aceptar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de confirmación */}
      {tokenExpired && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>
            <h2 style={styles.modalTitle}>El Token ha expirado!</h2>
            <p style={styles.modalText}>
              Seras redirigido a la pagina de inicio de sesion.
            </p>
            <div style={{ marginTop: "20px" }}>
              <Link to="/login" style={styles.confirmButton}>
                <span>Aceptar</span>
              </Link>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalBox: {
    backgroundColor: "#fff",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    maxWidth: "400px",
    width: "90%",
    textAlign: "center",
  },
  modalTitle: {
    marginBottom: "15px",
    color: "#333",
  },
  modalText: {
    color: "#555",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "30px",
    gap: "10px",
  },
  cancelButton: {
    flex: 1,
    padding: "10px",
    borderRadius: "8px",
    backgroundColor: "#e0e0e0",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
  },
  confirmButton: {
    flex: 1,
    padding: "10px",
    borderRadius: "8px",
    backgroundColor: "#4caf50",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
  },
};

export default StepsRegisterBusiness;
